import { render, staticRenderFns } from "./configurationListing.vue?vue&type=template&id=23e4ba7b&"
import script from "./configurationListing.vue?vue&type=script&lang=js&"
export * from "./configurationListing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports